<script setup>
defineProps({
  width: {
    type: Number,
    default: 16,
  },
  height: {
    type: Number,
    default: 16,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconForward">
      <path
        id="Vector"
        d="M5.07819 5.52681H11.5078L7.67747 1.71233C7.43681 1.4727 7.43681 1.08537 7.67747 0.845739C7.91814 0.606108 8.30714 0.606108 8.5478 0.845739L12.9739 5.25348C13.454 5.7309 13.454 6.50924 12.9739 6.98666L8.5478 11.3932C8.42778 11.5127 8.27021 11.5727 8.11264 11.5727C7.95507 11.5727 7.7975 11.5127 7.67747 11.3932C7.43681 11.1535 7.43681 10.7662 7.67747 10.5266L11.4684 6.75255H5.07819C4.06014 6.75255 3.23167 7.57747 3.23167 8.59115V14.7198C3.23167 15.0587 2.95592 15.3327 2.61616 15.3327C2.2764 15.3327 2.00065 15.0587 2.00065 14.7198V8.59115C2.00065 6.90147 3.38123 5.52681 5.07819 5.52681Z"
        fill="#434343"
      />
    </g>
  </svg>
</template>
